// UN member countries list (alphabetically sorted by English name)
// Includes both English and Ukrainian translations
export const COUNTRIES = [
  { value: "AF", label_en: "Afghanistan", label_ua: "Афганістан" },
  { value: "AL", label_en: "Albania", label_ua: "Албанія" },
  { value: "DZ", label_en: "Algeria", label_ua: "Алжир" },
  { value: "AD", label_en: "Andorra", label_ua: "Андорра" },
  { value: "AO", label_en: "Angola", label_ua: "Ангола" },
  { value: "AG", label_en: "Antigua and Barbuda", label_ua: "Антигуа і Барбуда" },
  { value: "AR", label_en: "Argentina", label_ua: "Аргентина" },
  { value: "AM", label_en: "Armenia", label_ua: "Вірменія" },
  { value: "AU", label_en: "Australia", label_ua: "Австралія" },
  { value: "AT", label_en: "Austria", label_ua: "Австрія" },
  { value: "AZ", label_en: "Azerbaijan", label_ua: "Азербайджан" },
  { value: "BS", label_en: "Bahamas", label_ua: "Багамські Острови" },
  { value: "BH", label_en: "Bahrain", label_ua: "Бахрейн" },
  { value: "BD", label_en: "Bangladesh", label_ua: "Бангладеш" },
  { value: "BB", label_en: "Barbados", label_ua: "Барбадос" },
  { value: "BY", label_en: "Belarus", label_ua: "Білорусь" },
  { value: "BE", label_en: "Belgium", label_ua: "Бельгія" },
  { value: "BZ", label_en: "Belize", label_ua: "Беліз" },
  { value: "BJ", label_en: "Benin", label_ua: "Бенін" },
  { value: "BT", label_en: "Bhutan", label_ua: "Бутан" },
  { value: "BO", label_en: "Bolivia", label_ua: "Болівія" },
  { value: "BA", label_en: "Bosnia and Herzegovina", label_ua: "Боснія і Герцеговина" },
  { value: "BW", label_en: "Botswana", label_ua: "Ботсвана" },
  { value: "BR", label_en: "Brazil", label_ua: "Бразилія" },
  { value: "BN", label_en: "Brunei", label_ua: "Бруней" },
  { value: "BG", label_en: "Bulgaria", label_ua: "Болгарія" },
  { value: "BF", label_en: "Burkina Faso", label_ua: "Буркіна-Фасо" },
  { value: "BI", label_en: "Burundi", label_ua: "Бурунді" },
  { value: "CV", label_en: "Cabo Verde", label_ua: "Кабо-Верде" },
  { value: "KH", label_en: "Cambodia", label_ua: "Камбоджа" },
  { value: "CM", label_en: "Cameroon", label_ua: "Камерун" },
  { value: "CA", label_en: "Canada", label_ua: "Канада" },
  { value: "CF", label_en: "Central African Republic", label_ua: "Центральноафриканська Республіка" },
  { value: "TD", label_en: "Chad", label_ua: "Чад" },
  { value: "CL", label_en: "Chile", label_ua: "Чилі" },
  { value: "CN", label_en: "China", label_ua: "Китай" },
  { value: "CO", label_en: "Colombia", label_ua: "Колумбія" },
  { value: "KM", label_en: "Comoros", label_ua: "Коморські Острови" },
  { value: "CG", label_en: "Congo", label_ua: "Конго" },
  { value: "CR", label_en: "Costa Rica", label_ua: "Коста-Рика" },
  { value: "HR", label_en: "Croatia", label_ua: "Хорватія" },
  { value: "CU", label_en: "Cuba", label_ua: "Куба" },
  { value: "CY", label_en: "Cyprus", label_ua: "Кіпр" },
  { value: "CZ", label_en: "Czech Republic", label_ua: "Чехія" },
  { value: "CD", label_en: "Democratic Republic of the Congo", label_ua: "Демократична Республіка Конго" },
  { value: "DK", label_en: "Denmark", label_ua: "Данія" },
  { value: "DJ", label_en: "Djibouti", label_ua: "Джибуті" },
  { value: "DM", label_en: "Dominica", label_ua: "Домініка" },
  { value: "DO", label_en: "Dominican Republic", label_ua: "Домініканська Республіка" },
  { value: "EC", label_en: "Ecuador", label_ua: "Еквадор" },
  { value: "EG", label_en: "Egypt", label_ua: "Єгипет" },
  { value: "SV", label_en: "El Salvador", label_ua: "Сальвадор" },
  { value: "GQ", label_en: "Equatorial Guinea", label_ua: "Екваторіальна Гвінея" },
  { value: "ER", label_en: "Eritrea", label_ua: "Еритрея" },
  { value: "EE", label_en: "Estonia", label_ua: "Естонія" },
  { value: "SZ", label_en: "Eswatini", label_ua: "Есватіні" },
  { value: "ET", label_en: "Ethiopia", label_ua: "Ефіопія" },
  { value: "FJ", label_en: "Fiji", label_ua: "Фіджі" },
  { value: "FI", label_en: "Finland", label_ua: "Фінляндія" },
  { value: "FR", label_en: "France", label_ua: "Франція" },
  { value: "GA", label_en: "Gabon", label_ua: "Габон" },
  { value: "GM", label_en: "Gambia", label_ua: "Гамбія" },
  { value: "GE", label_en: "Georgia", label_ua: "Грузія" },
  { value: "DE", label_en: "Germany", label_ua: "Німеччина" },
  { value: "GH", label_en: "Ghana", label_ua: "Гана" },
  { value: "GR", label_en: "Greece", label_ua: "Греція" },
  { value: "GD", label_en: "Grenada", label_ua: "Гренада" },
  { value: "GT", label_en: "Guatemala", label_ua: "Гватемала" },
  { value: "GN", label_en: "Guinea", label_ua: "Гвінея" },
  { value: "GW", label_en: "Guinea-Bissau", label_ua: "Гвінея-Бісау" },
  { value: "GY", label_en: "Guyana", label_ua: "Гаяна" },
  { value: "HT", label_en: "Haiti", label_ua: "Гаїті" },
  { value: "HN", label_en: "Honduras", label_ua: "Гондурас" },
  { value: "HU", label_en: "Hungary", label_ua: "Угорщина" },
  { value: "IS", label_en: "Iceland", label_ua: "Ісландія" },
  { value: "IN", label_en: "India", label_ua: "Індія" },
  { value: "ID", label_en: "Indonesia", label_ua: "Індонезія" },
  { value: "IR", label_en: "Iran", label_ua: "Іран" },
  { value: "IQ", label_en: "Iraq", label_ua: "Ірак" },
  { value: "IE", label_en: "Ireland", label_ua: "Ірландія" },
  { value: "IL", label_en: "Israel", label_ua: "Ізраїль" },
  { value: "IT", label_en: "Italy", label_ua: "Італія" },
  { value: "CI", label_en: "Ivory Coast", label_ua: "Кот-д'Івуар" },
  { value: "JM", label_en: "Jamaica", label_ua: "Ямайка" },
  { value: "JP", label_en: "Japan", label_ua: "Японія" },
  { value: "JO", label_en: "Jordan", label_ua: "Йорданія" },
  { value: "KZ", label_en: "Kazakhstan", label_ua: "Казахстан" },
  { value: "KE", label_en: "Kenya", label_ua: "Кенія" },
  { value: "KI", label_en: "Kiribati", label_ua: "Кірибаті" },
  { value: "KW", label_en: "Kuwait", label_ua: "Кувейт" },
  { value: "KG", label_en: "Kyrgyzstan", label_ua: "Киргизстан" },
  { value: "LA", label_en: "Laos", label_ua: "Лаос" },
  { value: "LV", label_en: "Latvia", label_ua: "Латвія" },
  { value: "LB", label_en: "Lebanon", label_ua: "Ліван" },
  { value: "LS", label_en: "Lesotho", label_ua: "Лесото" },
  { value: "LR", label_en: "Liberia", label_ua: "Ліберія" },
  { value: "LY", label_en: "Libya", label_ua: "Лівія" },
  { value: "LI", label_en: "Liechtenstein", label_ua: "Ліхтенштейн" },
  { value: "LT", label_en: "Lithuania", label_ua: "Литва" },
  { value: "LU", label_en: "Luxembourg", label_ua: "Люксембург" },
  { value: "MG", label_en: "Madagascar", label_ua: "Мадагаскар" },
  { value: "MW", label_en: "Malawi", label_ua: "Малаві" },
  { value: "MY", label_en: "Malaysia", label_ua: "Малайзія" },
  { value: "MV", label_en: "Maldives", label_ua: "Мальдіви" },
  { value: "ML", label_en: "Mali", label_ua: "Малі" },
  { value: "MT", label_en: "Malta", label_ua: "Мальта" },
  { value: "MH", label_en: "Marshall Islands", label_ua: "Маршаллові Острови" },
  { value: "MR", label_en: "Mauritania", label_ua: "Мавританія" },
  { value: "MU", label_en: "Mauritius", label_ua: "Маврикій" },
  { value: "MX", label_en: "Mexico", label_ua: "Мексика" },
  { value: "FM", label_en: "Micronesia", label_ua: "Мікронезія" },
  { value: "MD", label_en: "Moldova", label_ua: "Молдова" },
  { value: "MC", label_en: "Monaco", label_ua: "Монако" },
  { value: "MN", label_en: "Mongolia", label_ua: "Монголія" },
  { value: "ME", label_en: "Montenegro", label_ua: "Чорногорія" },
  { value: "MA", label_en: "Morocco", label_ua: "Марокко" },
  { value: "MZ", label_en: "Mozambique", label_ua: "Мозамбік" },
  { value: "MM", label_en: "Myanmar", label_ua: "М'янма" },
  { value: "NA", label_en: "Namibia", label_ua: "Намібія" },
  { value: "NR", label_en: "Nauru", label_ua: "Науру" },
  { value: "NP", label_en: "Nepal", label_ua: "Непал" },
  { value: "NL", label_en: "Netherlands", label_ua: "Нідерланди" },
  { value: "NZ", label_en: "New Zealand", label_ua: "Нова Зеландія" },
  { value: "NI", label_en: "Nicaragua", label_ua: "Нікарагуа" },
  { value: "NE", label_en: "Niger", label_ua: "Нігер" },
  { value: "NG", label_en: "Nigeria", label_ua: "Нігерія" },
  { value: "KP", label_en: "North Korea", label_ua: "Північна Корея" },
  { value: "MK", label_en: "North Macedonia", label_ua: "Північна Македонія" },
  { value: "NO", label_en: "Norway", label_ua: "Норвегія" },
  { value: "OM", label_en: "Oman", label_ua: "Оман" },
  { value: "PK", label_en: "Pakistan", label_ua: "Пакистан" },
  { value: "PW", label_en: "Palau", label_ua: "Палау" },
  { value: "PS", label_en: "Palestine", label_ua: "Палестина" },
  { value: "PA", label_en: "Panama", label_ua: "Панама" },
  { value: "PG", label_en: "Papua New Guinea", label_ua: "Папуа-Нова Гвінея" },
  { value: "PY", label_en: "Paraguay", label_ua: "Парагвай" },
  { value: "PE", label_en: "Peru", label_ua: "Перу" },
  { value: "PH", label_en: "Philippines", label_ua: "Філіппіни" },
  { value: "PL", label_en: "Poland", label_ua: "Польща" },
  { value: "PT", label_en: "Portugal", label_ua: "Португалія" },
  { value: "QA", label_en: "Qatar", label_ua: "Катар" },
  { value: "RO", label_en: "Romania", label_ua: "Румунія" },
  { value: "RW", label_en: "Rwanda", label_ua: "Руанда" },
  { value: "KN", label_en: "Saint Kitts and Nevis", label_ua: "Сент-Кітс і Невіс" },
  { value: "LC", label_en: "Saint Lucia", label_ua: "Сент-Люсія" },
  { value: "VC", label_en: "Saint Vincent and the Grenadines", label_ua: "Сент-Вінсент і Гренадини" },
  { value: "WS", label_en: "Samoa", label_ua: "Самоа" },
  { value: "SM", label_en: "San Marino", label_ua: "Сан-Марино" },
  { value: "ST", label_en: "Sao Tome and Principe", label_ua: "Сан-Томе і Принсіпі" },
  { value: "SA", label_en: "Saudi Arabia", label_ua: "Саудівська Аравія" },
  { value: "SN", label_en: "Senegal", label_ua: "Сенегал" },
  { value: "RS", label_en: "Serbia", label_ua: "Сербія" },
  { value: "SC", label_en: "Seychelles", label_ua: "Сейшельські Острови" },
  { value: "SL", label_en: "Sierra Leone", label_ua: "Сьєрра-Леоне" },
  { value: "SG", label_en: "Singapore", label_ua: "Сінгапур" },
  { value: "SK", label_en: "Slovakia", label_ua: "Словаччина" },
  { value: "SI", label_en: "Slovenia", label_ua: "Словенія" },
  { value: "SB", label_en: "Solomon Islands", label_ua: "Соломонові Острови" },
  { value: "SO", label_en: "Somalia", label_ua: "Сомалі" },
  { value: "ZA", label_en: "South Africa", label_ua: "Південна Африка" },
  { value: "KR", label_en: "South Korea", label_ua: "Південна Корея" },
  { value: "SS", label_en: "South Sudan", label_ua: "Південний Судан" },
  { value: "ES", label_en: "Spain", label_ua: "Іспанія" },
  { value: "LK", label_en: "Sri Lanka", label_ua: "Шрі-Ланка" },
  { value: "SD", label_en: "Sudan", label_ua: "Судан" },
  { value: "SR", label_en: "Suriname", label_ua: "Суринам" },
  { value: "SE", label_en: "Sweden", label_ua: "Швеція" },
  { value: "CH", label_en: "Switzerland", label_ua: "Швейцарія" },
  { value: "SY", label_en: "Syria", label_ua: "Сирія" },
  { value: "TJ", label_en: "Tajikistan", label_ua: "Таджикистан" },
  { value: "TZ", label_en: "Tanzania", label_ua: "Танзанія" },
  { value: "TH", label_en: "Thailand", label_ua: "Таїланд" },
  { value: "TL", label_en: "Timor-Leste", label_ua: "Тимор-Лешті" },
  { value: "TG", label_en: "Togo", label_ua: "Того" },
  { value: "TO", label_en: "Tonga", label_ua: "Тонга" },
  { value: "TT", label_en: "Trinidad and Tobago", label_ua: "Тринідад і Тобаго" },
  { value: "TN", label_en: "Tunisia", label_ua: "Туніс" },
  { value: "TR", label_en: "Turkey", label_ua: "Туреччина" },
  { value: "TM", label_en: "Turkmenistan", label_ua: "Туркменістан" },
  { value: "TV", label_en: "Tuvalu", label_ua: "Тувалу" },
  { value: "UG", label_en: "Uganda", label_ua: "Уганда" },
  { value: "UA", label_en: "Ukraine", label_ua: "Україна" },
  { value: "AE", label_en: "United Arab Emirates", label_ua: "Об'єднані Арабські Емірати" },
  { value: "GB", label_en: "United Kingdom", label_ua: "Велика Британія" },
  { value: "US", label_en: "United States", label_ua: "Сполучені Штати Америки" },
  { value: "UY", label_en: "Uruguay", label_ua: "Уругвай" },
  { value: "UZ", label_en: "Uzbekistan", label_ua: "Узбекистан" },
  { value: "VU", label_en: "Vanuatu", label_ua: "Вануату" },
  { value: "VA", label_en: "Vatican City", label_ua: "Ватикан" },
  { value: "VE", label_en: "Venezuela", label_ua: "Венесуела" },
  { value: "VN", label_en: "Vietnam", label_ua: "В'єтнам" },
  { value: "YE", label_en: "Yemen", label_ua: "Ємен" },
  { value: "ZM", label_en: "Zambia", label_ua: "Замбія" },
  { value: "ZW", label_en: "Zimbabwe", label_ua: "Зімбабве" },
];

// Ukrainian regions (oblasts)
export const UKRAINE_REGIONS = [
  { value: "Вінницька", label: "Вінницька область" },
  { value: "Волинська", label: "Волинська область" },
  { value: "Дніпропетровська", label: "Дніпропетровська область" },
  { value: "Донецька", label: "Донецька область" },
  { value: "Житомирська", label: "Житомирська область" },
  { value: "Закарпатська", label: "Закарпатська область" },
  { value: "Запорізька", label: "Запорізька область" },
  { value: "Івано-Франківська", label: "Івано-Франківська область" },
  { value: "Київ", label: "м. Київ" },
  { value: "Київська", label: "Київська область" },
  { value: "Кіровоградська", label: "Кіровоградська область" },
  { value: "Луганська", label: "Луганська область" },
  { value: "Львівська", label: "Львівська область" },
  { value: "Миколаївська", label: "Миколаївська область" },
  { value: "Одеська", label: "Одеська область" },
  { value: "Полтавська", label: "Полтавська область" },
  { value: "Рівненська", label: "Рівненська область" },
  { value: "Сумська", label: "Сумська область" },
  { value: "Тернопільська", label: "Тернопільська область" },
  { value: "Харківська", label: "Харківська область" },
  { value: "Херсонська", label: "Херсонська область" },
  { value: "Хмельницька", label: "Хмельницька область" },
  { value: "Черкаська", label: "Черкаська область" },
  { value: "Чернівецька", label: "Чернівецька область" },
  { value: "Чернігівська", label: "Чернігівська область" },
  { value: "Севастополь", label: "м. Севастополь" },
];

// Lookup maps for display formatting
const countriesByCode = new Map(COUNTRIES.map(c => [c.value, c]));
const countriesByLabelUa = new Map(COUNTRIES.map(c => [c.label_ua, c]));
const regionsByValue = new Map(UKRAINE_REGIONS.map(r => [r.value, r]));
const regionsByLabel = new Map(UKRAINE_REGIONS.map(r => [r.label, r]));

/**
 * Convert a country code (e.g. "UA") or existing name to the full Ukrainian name.
 * If already a full name (e.g. "Україна"), returns as-is.
 */
export function getCountryDisplayName(value: string | null | undefined): string {
  if (!value) return '';
  // Try as country code first
  const byCode = countriesByCode.get(value);
  if (byCode) return byCode.label_ua;
  // Already a full name?
  if (countriesByLabelUa.has(value)) return value;
  // Unknown value, return as-is
  return value;
}

/**
 * Normalize a Ukrainian region however it was stored ("Львівська" or
 * "Львівська область") to the picker value ("Львівська"). Anything the
 * dictionary does not know (legacy Bubble ids, foreign regions) comes back
 * unchanged.
 */
export function toRegionValue(value: string | null | undefined): string {
  if (!value) return '';
  if (regionsByValue.has(value)) return value;
  const byLabel = regionsByLabel.get(value);
  return byLabel ? byLabel.value : value;
}

/** True when the value names one of the Ukrainian regions, in either form. */
export function isKnownUkrainianRegion(value: string | null | undefined): boolean {
  return !!value && (regionsByValue.has(value) || regionsByLabel.has(value));
}

/**
 * Convert a region value (e.g. "Вінницька") to the full label (e.g. "Вінницька область").
 * Handles values already containing "область" or "м." prefix.
 */
export function getRegionDisplayName(value: string | null | undefined): string {
  if (!value) return '';
  // Try as stored value (without "область")
  const byValue = regionsByValue.get(value);
  if (byValue) return byValue.label;
  // Already a full label?
  if (regionsByLabel.has(value)) return value;
  // Unknown value, return as-is
  return value;
}
